module.exports = __webpack_public_path__ + "img/7.495aca10.png";